import { ApiService } from './../services/api.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageRessource'
})
export class ImageRessourcePipe implements PipeTransform {

  constructor(private apiService: ApiService) { }
  transform(user: any, type): any {
    if (type === 'video') {
      return this.apiService.url + '/video?value=' + user;
    }
    let image = null;
    if (typeof user === 'string') {
      image = user;
    } else {
      image = user.lienPhotoProfil;
    }
    return image ? this.apiService.url + '/image?value=' + image : 'assets/user-orange.png';
    // console.log('lien: ', 'http://10.172.212.75:32169/openstack/afficher?nom-image=' +
    //   image + '&container=kyc_archives&type-fichier=image');
    // return image ? 'http://10.172.212.75:32169/openstack/afficher?nom-image=' +
    //   image + '.jpg&container=kyc_archives&type-fichier=image' : 'assets/user-orange.png';
  }

}
